"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INetStatsSummarySchema = exports.INetStatsSchema = void 0;
const zod_1 = require("zod");
const BoundaryCharacteristicStateSummaryExternal_1 = require("./BoundaryCharacteristicStateSummaryExternal");
const BoundaryCharacteristicStateSerialized_1 = require("./BoundaryCharacteristicStateSerialized");
const ISerializedCircuitState_1 = require("./ISerializedCircuitState");
exports.INetStatsSchema = zod_1.default.object({
    net: zod_1.default.string(),
    characteristics: zod_1.default.lazy(() => BoundaryCharacteristicStateSerialized_1.BoundaryCharacteristicStateSerializedSchema).array(),
    circuitStates: zod_1.default.lazy(() => ISerializedCircuitState_1.SerializedCircuitStateMapSchema).optional(),
});
exports.INetStatsSummarySchema = zod_1.default.object({
    net: zod_1.default.string(),
    characteristics: zod_1.default.lazy(() => BoundaryCharacteristicStateSummaryExternal_1.BoundaryCharacteristicStateSummaryExternalSchema).array(),
});
//# sourceMappingURL=INetStats.js.map